// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { platformAdminIdentityUserMemberships } from "./platform-admin-identity-user-memberships";

export const platformAdminIdentityUserWorkflows = {
  actions: {
    assignPlatformRole: "平台角色分配",
    createUser: "新建平台用户",
    editUser: "编辑平台用户",
  },
  drawers: {
    authorization: "授权 · {name}",
    authorizationShort: "授权",
    userEdit: "编辑平台用户 · {name}",
    userEditShort: "编辑平台用户",
    ...platformAdminIdentityUserMemberships.drawers,
  },
  alerts: {
    userCreatePolicy:
      "平台用户创建后默认需要首次登录修改密码；如填写到期时间，到期后将禁止继续登录与刷新会话。",
    userCreateApplicationRoles:
      "可选：创建成功后会按“应用角色映射”逐条创建用户级应用角色映射；若部分失败，会明确提示“用户已创建，但部分映射失败”。",
    userCreateOidcApplicationRoles:
      "可选：创建成功后会按“OIDC 应用角色授权”逐条创建用户级角色映射；当前仅支持 airange-admin 角色目录。",
    userEditApplicationRoles:
      "保存编辑时会先更新用户基础信息与平台角色，再对用户级应用角色映射执行差量新增/删除。平台角色映射与基础身份映射不会被误改。",
    ...platformAdminIdentityUserMemberships.alerts,
  },
  confirms: {
    resetPasswordTitle: "重置平台用户密码",
    resetPasswordDescription: "确认重置 {username} 的密码吗？临时密码只会在本次响应中展示。",
    kickoutTitle: "踢下线平台用户",
    kickoutDescription: "确认让该用户当前会话立即失效吗？用户需要重新登录。",
    batchDisableDescription: "将 {count} 个用户设为 {status}",
    impersonateTitle: "附身平台用户",
    impersonateDescription:
      "确认以 {username} 的身份进入当前平台工作台吗？此操作仅作用于当前平台前端，可随时退出附身。",
    updateUserStatusTitle: "更新平台用户状态",
    updateUserStatusDescription: "确认将 {username} 更新为 {status} 吗？",
    ...platformAdminIdentityUserMemberships.confirms,
  },
  messages: {
    userCreated: "平台用户已创建",
    userCreatedWithRoleMappings: "平台用户已创建，并已完成 {count} 条应用角色映射",
    userCreatedWithPartialRoleMappings:
      "平台用户已创建，但有 {failedCount} 条应用角色映射失败：{details}",
    userUpdated: "平台用户已更新",
    userUpdatedWithPartialRoleMappings:
      "平台用户已更新，但有 {failedCount} 条应用角色映射更新失败：{details}",
    userMappingApplicationUnavailable: "应用不可用：{application} / {role}",
    userMappingCreateFailedForApp: "应用角色映射失败：{application} / {role}",
    userMappingDeleteFailedForApp: "应用角色映射删除失败：{application} / {role}",
    userCreateFailed: "平台用户创建失败",
    userUpdateFailed: "平台用户更新失败",
    userStatusUpdated: "平台用户状态已更新",
    userStatusUpdateFailed: "平台用户状态更新失败",
    passwordReset: "平台用户密码已重置",
    passwordResetFailed: "平台用户密码重置失败",
    kickoutSuccess: "平台用户已踢下线",
    kickoutFailed: "平台用户踢下线失败",
    batchKickoutSuccess: "已踢下线 {count} 个用户",
    batchKickoutAlreadyOffline: "已离线 {count} 个用户",
    batchDisableSuccess: "已停用 {count} 个用户",
    batchDisableAlreadyInactive: "已停用 {count} 个用户",
    batchSkippedCurrentUser: "已跳过当前用户 {count} 个",
    batchUsersNotFound: "未命中用户 {count} 个",
    impersonateFailed: "附身平台用户失败",
    impersonateSelfDisabled: "不能附身自己",
    impersonateInactiveDisabled: "用户未启用，不能附身",
    impersonationBanner:
      "当前正以 {target}（{targetUsername}）身份操作，原管理员为 {actor}（{actorUsername}）。",
    temporaryPasswordVisibleOnce:
      "临时密码仅本次展示，请立即复制并交给用户。用户下次登录必须修改密码。",
    noTargetUser: "未选择目标用户",
    usersPartialLoadFailed: "用户列表加载失败，但其他身份数据已保留",
    ...platformAdminIdentityUserMemberships.messages,
  },
  forms: {
    userCreate: "新建平台用户",
    userEdit: "编辑平台用户",
    userEditShort: "编辑平台用户",
    username: "用户名",
    nickname: "昵称",
    nicknamePlaceholder: "可空，默认使用用户名",
    phone: "手机号码",
    initialPassword: "初始密码",
    expiresAt: "到期时间",
    expiresAtPlaceholder: "可选；为空表示长期有效",
    applicationRoleMappings: "应用角色映射",
    addApplicationRoleMapping: "新建应用角色映射",
    applicationRoleMappingItem: "映射 #{index}",
    applicationAdminRole: "管理员（admin）",
    applicationPlatformAdminRole: "平台管理员（platform_admin）",
    oidcApplicationRoleMappings: "用户级 OIDC 应用角色授权",
    addOidcApplicationRoleMapping: "新增 OIDC 应用角色授权",
    oidcApplicationRoleMappingItem: "OIDC 授权 #{index}",
    targetUser: "目标用户",
    oidcApplicationOwner: "OIDC 应用",
    platformRoleAuthorization: "平台角色授权",
    userLevelOidcApplicationRoleMappingsHint:
      "这里维护的是用户级 OIDC 应用角色授权，不会展示通过平台角色或应用 grant 自动生效的访问权。对 airange-admin 来说，很多权限会由平台角色自动映射，通常不需要重复单独授权。",
    duplicateAirangeAdminUserLevelAuthorizationHint:
      "当前用户已拥有会自动映射到 airange-admin 的平台角色：{roles}。如果下面再给 airange-admin 授同名用户级角色，通常只是重复授权。",
    requiredUsername: "请输入用户名",
    requiredInitialPassword: "请输入初始密码",
    requiredPlatformRoles: "请至少选择一个平台角色",
    requiredUserSubject: "请选择具体用户",
    selectUserSubject: "选择具体用户",
    userSubjectEmpty: "尚未选择具体用户",
    userSubjectPickerTitle: "选择角色映射用户主体",
    userSubjectPickerEmpty: "暂无可选择的身份用户",
    requiredTargetOidcBusinessRole: "请选择目标 OIDC 业务角色",
    requiredOidcApplicationOwner: "请选择 OIDC 应用",
    targetOidcBusinessRole: "目标 OIDC 业务角色",
    ...platformAdminIdentityUserMemberships.forms,
  },
} as const;
